var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main"},[_vm._v("\t\t\t\t\n\t© "+_vm._s(_vm.anio)+" \n")])
}
var staticRenderFns = []

export { render, staticRenderFns }